import { styled } from '@mui/material/styles';

export const Actions = styled('div')`
  padding: 0 4px;
`;
